import React, { useState } from 'react'
import { useGetPoItemByIdQuery } from '../../../redux/ErpServices/PoServices'
import { Loader } from '../../../Basic/components'
import { substract } from '../../../Utils/helper'
import AccessoryPoItemInwardReport from './AccessoryPoItemInwardReport'
import Modal from '../../../UiComponents/Modal'
import AccessoryItemReturnReport from './AccessoryPoItemReturnReport'
import AccessoryItemCancelReport from './AccessoryPoItemCancelReport'

const AccessoryPoItem = ({ id, index, dataObj }) => {
    const [inwardReport, setInwardReport] = useState(false)
    const [returnReport, setReturnReport] = useState(false)
    const [cancelReport, setCancelReport] = useState(false)
    const { data, isLoading, isFetching } = useGetPoItemByIdQuery({ id }, { skip: !id })
    if (isLoading || isFetching) return <Loader />
    const poItem = data.data
    let poQty = parseFloat(poItem.qty).toFixed(3)
    let cancelQty = poItem.alreadyCancelData?._sum.qty ? poItem.alreadyCancelData._sum.qty : "0.000";
    let alreadyInwardedQty = poItem.alreadyInwardedData?._sum?.qty ? parseFloat(poItem.alreadyInwardedData._sum.qty).toFixed(3) : "0.000";
    let alreadyReturnedQty = poItem.alreadyReturnedData?._sum?.qty ? parseFloat(poItem.alreadyReturnedData._sum.qty).toFixed(3) : "0.000";
    let balanceQty = substract(substract(poQty, cancelQty), substract(alreadyInwardedQty, alreadyReturnedQty)).toFixed(3)
    let alreadyBillQty = poItem?.alreadyBillData?._sum?.qty ? poItem?.alreadyBillData._sum.qty : 0;
    let balBillQty = substract(poQty, alreadyBillQty);
    balBillQty = balBillQty > 0 ? balBillQty : 0
    return (
        <>
            <Modal isOpen={inwardReport} onClose={() => setInwardReport(false)} >
                <AccessoryPoItemInwardReport dataObj={dataObj} poItem={poItem} inwardItems={poItem.PoInwardReturnItems.filter(item => item.PurchaseInwardOrReturn.inwardOrReturn === "PurchaseInward")} />
            </Modal>
            <Modal isOpen={returnReport} onClose={() => setReturnReport(false)}>
                <AccessoryItemReturnReport dataObj={dataObj} poItem={poItem}
                    inwardItems={poItem.PoInwardReturnItems.filter(item => item.PurchaseInwardOrReturn.inwardOrReturn === "PurchaseReturn")} />
            </Modal>
            <Modal isOpen={cancelReport} onClose={() => setCancelReport(false)}>
                <AccessoryItemCancelReport dataObj={dataObj} poItem={poItem}
                    inwardItems={poItem.PoInwardReturnItems.filter(item => item.PurchaseInwardOrReturn.inwardOrReturn === "PurchaseCancel")} />
            </Modal>
            <tr key={id} className='table-row'>
                <td className='text-left   table-data'>{index + 1}</td>
                <td className='text-left   table-data'>{poItem.Accessory.aliasName}</td>
                <td className='text-left   table-data'>{poItem.Accessory.accessoryItem.name}</td>
                <td className='text-left   table-data'>{poItem.Accessory.accessoryItem.AccessoryGroup.name}</td>
                <td className='text-left   table-data'>{poItem.Color.name}</td>
                <td className='text-right   table-data'>{poItem.Size.name}</td>
                <td className='text-left   table-data'>{poItem.Uom.name}</td>
                <td className='text-right  table-data'>{poQty}</td>
                <td className='text-right   table-data' onClick={() => setCancelReport(true)}>{cancelQty}</td>
                <td className='text-right  table-data' onClick={() => setInwardReport(true)}>{alreadyInwardedQty}</td>
                <td className='text-right  table-data' onClick={() => setReturnReport(true)}>{alreadyReturnedQty}</td>
                <td className='text-right  table-data'>{balanceQty}</td>
                <td className='text-right   table-data'>{alreadyBillQty}</td>
                <td className='text-right   table-data'>{balBillQty}</td>
            </tr>
        </>
    )
}

export default AccessoryPoItem
